// TODO: We should eliminate this rule bypass when our user object is camel cased
/* eslint-disable @typescript-eslint/naming-convention */

import { User } from 'types/User';

const isBot = window.navigator.webdriver;

export const SegmentService = {
  trackPage(pathname: string) {
    if (isBot === true) {
      return;
    }
    if (window.analytics) {
      window.analytics.page(pathname);
    }
  },

  // Expects a BlueCargo user and transforms it to the
  // shape expected by segment.
  identifyUser(user: User) {
    if (isBot === true || !user) {
      return;
    }
    if (window.analytics && user && user.id) {
      const {
        id,
        email,
        first_name,
        last_name,
        phone_number,
        is_admin,
        company,
        permissions,
        beta_access,
        company_role,
        date_joined,
        last_login,
        email_validated,
        teamMembers,
        company_scac,
        subscription_period,
        subscription_renewal_date,
        billing_email,
        per_diem_report_credit_left,
      } = user;

      // standardize identify properties
      const firstname = first_name;
      const lastname = last_name;
      const jobtitle = company_role;
      const nb_containers_added = company?.container_credits_used;
      const user_id = id;
      const platform_joined_date = date_joined;
      const platform_last_login = last_login;
      const is_platform_administrator = is_admin;
      const django_link = `https://api.erl.bluecargo.io/core/admin/users/customuser/?q=${email}`;
      const mixpanel_link = `https://mixpanel.com/project/2588732/view/3127896/app/profile#distinct_id=${id}`;
      const email_platform_validated = email_validated;
      const company_plan = company?.pack_display_name;
      const stripe_bucket = company?.pack_container_volume;
      const company_nature = company?.company_type_detail;
      const container_credits_limit = company?.container_credits_limit;

      // standardize group properties
      const billing_address = company?.address;
      const pack_id = company?.pack;
      const maxUser = permissions?.max_user;
      const container_credits_used = company?.container_credits_used;
      const nb_users = teamMembers.length;
      const trial_end_date = company?.trial_end;
      const phone = phone_number;
      const website = `https://www.${user.company_scac}.com`;
      const per_diem_report_credit_consumed =
        permissions.initial_credit - per_diem_report_credit_left;

      window.analytics.identify(id, {
        email,
        firstname,
        lastname,
        phone,
        jobtitle,
        nb_containers_added,
        user_id,
        platform_joined_date,
        platform_last_login,
        is_platform_administrator,
        django_link,
        mixpanel_link,
        email_platform_validated,
        company_plan,
        stripe_bucket,
        beta_access,
        company: company?.name,
        company_permissions: company?.permissions,
        user_permissions: user.extra_permissions || [],
        company_scac,
        company_nature,
        container_credits_limit,
        // eslint-disable-next-line @typescript-eslint/ban-types
      } as Object);

      window.analytics.group(company_scac, {
        name: company?.name,
        company_nature,
        company_scac,
        billing_address,
        company_plan,
        stripe_bucket,
        container_credits_limit,
        container_credits_used,
        nb_users,
        subscription_period,
        subscription_renewal_date,
        billing_email,
        trial_end_date,
        per_diem_report_credit_left,
        per_diem_report_credit_consumed,
        pack_id,
        maxUser,
        website,
        autoJoinEmailDomain: company?.auto_join_email_domain || false,
        otherType: company?.other_type || '',
        companyType: company_nature,
        expectedContainerVolume: company?.expected_container_volume || 0,
        portCollectionCodes: company?.port_collections.map((p) => p.code) || [],
      });
    }
  },

  trackEvent(
    eventTitle: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    properties?: Record<string, any>,
    options?: SegmentAnalytics.SegmentOpts
  ) {
    if (isBot === true) {
      return;
    }

    if (['BULK', 'ADXH'].includes(properties?.companyScac)) {
      // eslint-disable-next-line no-console
      console.log('Not tracking BlueCargo event', eventTitle, properties, options);
      return;
    }

    if (window.analytics) {
      window.analytics.track(eventTitle, properties, options);
    }
  },

  trackEventNoSlack(
    eventTitle: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    properties?: Record<string, any>,
    options?: SegmentAnalytics.SegmentOpts
  ) {
    this.trackEvent(eventTitle, properties, {
      ...options,
      integrations: {
        ...options?.integrations,
        Slack: false,
      },
    });
  },
};

/**
 * An enum of titles to use for segment events; this should prevent typos
 */
export enum SegmentEvent {
  ShipmentsAddTableFilterUsed = 'Added shipments table filter used',
  ShipmentsWatchlistFilterUsed = 'Watchlist filter used',
  ContainerExported = 'Container exported',
  ShipmentsHistoryInfoExpanded = 'Container side drawer history info update clicked',
  ShipmentWatchlistPrefilteredViewUsed = 'Shipment watchlist pre-filtered view clicked',
  ShipmentsHistoricalPerDiemSearched = 'Historical per diem searched',
}
